import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import type { TestKind } from '../utils/scheduleUtils';

interface TestTypeSelectModalProps {
  show: boolean;
  onHide: () => void;
  subjectIndex: number;
  onConfirm: (testTypes: TestKind[], insertToCurrentDay: boolean) => void;
}

const TestTypeSelectModal: React.FC<TestTypeSelectModalProps> = ({
  show,
  onHide,
  subjectIndex,
  onConfirm,
}) => {
  const isFirstSubject = subjectIndex === 0;
  const [weekly, setWeekly] = useState(true);
  const [revision, setRevision] = useState(false);

  useEffect(() => {
    if (show) {
      setWeekly(true);
      setRevision(false);
    }
  }, [show, subjectIndex]);

  const handleConfirm = (insertToCurrentDay: boolean) => {
    const testTypes: TestKind[] = [];
    if (weekly) testTypes.push('Weekly Test');
    if (revision && !isFirstSubject) testTypes.push('Revision Test');

    if (testTypes.length === 0) {
      alert('Select at least Weekly Test or Revision Test.');
      return;
    }

    onConfirm(testTypes, insertToCurrentDay);
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Configure Test Day</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted small mb-3">
          {isFirstSubject
            ? 'First subject: Weekly Test only.'
            : 'Select Weekly and/or Revision Test for this day.'}
        </p>
        <Form>
          <Form.Check
            type="checkbox"
            id="test-weekly"
            label="Weekly Test"
            checked={weekly}
            onChange={(e) => setWeekly(e.target.checked)}
          />
          <Form.Check
            type="checkbox"
            id="test-revision"
            label="Revision Test"
            checked={revision}
            disabled={isFirstSubject}
            onChange={(e) => setRevision(e.target.checked)}
            className="mt-2"
          />
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="secondary" onClick={() => handleConfirm(true)}>
          Insert to Current Day
        </Button>
        <Button variant="primary" onClick={() => handleConfirm(false)}>
          Insert to Next Day
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TestTypeSelectModal;
